import { createFileRoute } from '@tanstack/react-router';
import { OrganizationLayout } from '@uturn/portal/modules/org/layout';
import z from 'zod';

const OrgIdParamSchema = z.object({
	orgId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/_protected/org/$orgId/settings')({
	params: {
		parse: (raw) => OrgIdParamSchema.parse(raw),
	},
	component: OrganizationLayout,
});
